import React from "react";
import "../css/contact.css";

import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider"

const Kontakt = () => {


  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className="contact">
        <div className="container container-contact">
        <form action="https://formsubmit.co/22ad5054a7c3b9bb33cc168befd80489" method="POST">
            <div className={darkMode ? 'contact__box dark' : ' contact__box light'}>
              <h2 className={darkMode ? 'contact__heading dark-text' : 'contact__heading light-text'}>Kontaktujte nás</h2>
              <div className="contact__form">
                <div className="contact__firstname">
                  <span className={darkMode ? 'dark-second-text' : ''} >Celé Jméno</span>
                  <input type="text" name="name" required />
                </div>

                <div className="contact__e-mail">
                  <span className={darkMode ? 'dark-second-text' : ''}>E-mail</span>
                  <input type="email" name="email" required />
                </div>
                <div className="contact__message">
                  <span className={darkMode ? 'dark-second-text' : ''}>Zpráva</span>
                  <textarea name="message" required></textarea>
                </div>
                <button type="submit" className={darkMode ? 'contact__button dark-button-text' : 'contact__button light-button-text'}>
                  <span className="contact__button-span">Odeslat</span>
                </button>
              </div>
            </div>
          </form> 
        </div>
      </section>
    </>
  );
};

export default Kontakt;
